import { useEffect } from 'react';
import { KanbanBoard } from '@/components/pipeline/kanban-board';
import { BonusBar } from '@/components/pipeline/bonus-bar';
import { trpc } from '@/trpc';
import { usePipelineStore } from '@/stores/pipeline.store';
import { useSettingsStore } from '@/stores/settings.store';

export function PipelinePage() {
  const { data, isLoading } = (trpc as any).deal?.byStage?.useQuery?.() ?? { data: null, isLoading: false };
  const { data: settings } = (trpc as any).settings?.get?.useQuery?.() ?? { data: null };
  const setDeals = usePipelineStore((s) => s.setDeals);
  const setBaseCurrency = useSettingsStore((s) => s.setBaseCurrency);

  useEffect(() => {
    if (data) {
      const deals = (data as any[]).flatMap((group: any) => group.deals ?? []);
      setDeals(deals);
    }
  }, [data]);

  useEffect(() => {
    if (settings?.baseCurrency) setBaseCurrency(settings.baseCurrency);
  }, [settings?.baseCurrency]);

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold tracking-tight">Pipeline</h1>
          <p className="text-muted-foreground">Drag deals to Signed to see your Q2 bonus update live.</p>
        </div>
      </div>

      <BonusBar />
      {isLoading ? (
        <div className="flex gap-4 overflow-x-auto pb-4">
          {[1, 2, 3, 4].map((i) => (
            <div key={i} className="w-72 shrink-0 rounded-lg border bg-muted/30 h-48 animate-pulse" />
          ))}
        </div>
      ) : (
        <KanbanBoard />
      )}
    </div>
  );
}
